import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { showQuotaExceededModal, showAccessDenied } from 'store/actions/globalActions';
import {
  setVideoDownloading,
  getVideoPermissions,
  userHasRemainingQuota,
  videoDownloaded,
  setPermissions,
} from 'store/actions/videos';
import { ASSET_TYPES, DOWNLOAD_DEBOUNCE_DELAY } from 'components/utils/constants';
import Dropdown from 'components/elements/common/dropdown/Dropdown';
import AddToCollectionButton from 'components/elements/common/permission/AddToCollectionButton';
import NavigationBar from 'elements/common/navigationbar/NavigationBar';
import ShareButton from 'elements/common/permission/ShareButton';
import { VIDEO_RENDITIONS } from '../../../utils/constants';

class VideoCommands extends Component {
  constructor(props) {
    super(props);
    this.debounceDownloadWatermark = debounce(() => this.downloadRendition(VIDEO_RENDITIONS.lowres.label), DOWNLOAD_DEBOUNCE_DELAY, { leading: true, trailing: false });
    this.debounceDownloadCompressed = debounce(() => this.downloadRendition(VIDEO_RENDITIONS.compressed.label), DOWNLOAD_DEBOUNCE_DELAY, { leading: true, trailing: false });
    this.debounceDownloadHighRes = debounce(() => this.downloadRendition(VIDEO_RENDITIONS.highres.label), DOWNLOAD_DEBOUNCE_DELAY, { leading: true, trailing: false });
  }

  componentDidMount() {
    const { id } = this.props;
    this.props.getVideoPermissions(id);
    this.props.userHasRemainingQuota();
  }

  componentWillUnmount() {
    this.props.setPermissions({});
  }

  async downloadRendition(rendition) {
    const { id, permissions: { renditions } } = this.props;
    await this.props.videoDownloaded(id, renditions[rendition]);
  }

  checkUserAndDownload(event, downloadFunc) {
    const { hasRemainingQuota, permissions: { permissions } } = this.props;
    if (!hasRemainingQuota || !(permissions && permissions.download)) {
      event.stopPropagation();
      event.preventDefault();
      return (!hasRemainingQuota) ? this.props.showQuotaExceededModal() : this.props.showAccessDenied();
    }

    this.props.setVideoDownloading();
    downloadFunc();
  }

  renderDownloadButton(rendition, downloadFunc) {
    const { label, encoding } = rendition;
    const { permissions: { renditions } } = this.props;
    const downloadUrl = renditions && renditions[label];
    return (
      <li>
        {downloadUrl && <a className="video-download-option" target="_blank" rel="noopener noreferrer" href={downloadUrl}
           onClick={e => this.checkUserAndDownload(e, downloadFunc)} download>{encoding}</a>
        || <span className="video-download-option-inactive">{encoding}</span>}
      </li>
    );
  }

  render() {
    const { id, title } = this.props;

    return (
      <NavigationBar
        className="video-detail-commands"
        leftSide={(
          <ShareButton mediaType={ASSET_TYPES.video.type} context={ASSET_TYPES.video.context} id={id} name={title}/>
        )}
        center={(
          <React.Fragment>
            <Dropdown title={'Low Resolution'} className={'low-res-download'} onOpenClassName={'open'} closeOnClick>
              <ul>
                {this.renderDownloadButton(VIDEO_RENDITIONS.lowres, this.debounceDownloadWatermark)}
              </ul>
            </Dropdown>
            <Dropdown title={'High Resolution'} className={'high-res-download'} onOpenClassName={'open'} closeOnClick>
              <ul>
                {this.renderDownloadButton(VIDEO_RENDITIONS.compressed, this.debounceDownloadCompressed)}
                {this.renderDownloadButton(VIDEO_RENDITIONS.highres, this.debounceDownloadHighRes)}
              </ul>
            </Dropdown>
          </React.Fragment>
        )}
        rightSide={(
          <AddToCollectionButton mediaType={ASSET_TYPES.video.type} id={id} className="button--add-asset"/>
        )}
        hideLayoutOptions
      />
    );
  }
}

const mapStateToProps = ({ videos: { permissions, hasRemainingQuota } }) => ({
  permissions,
  hasRemainingQuota,
});

const mapDispatchToProps = {
  setPermissions,
  setVideoDownloading,
  videoDownloaded,
  getVideoPermissions,
  userHasRemainingQuota,
  showQuotaExceededModal,
  showAccessDenied,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoCommands);
